// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import moment from 'moment';
import { Observable } from 'rxjs';
import {
  OperationalState,
  TicketStatus,
  TicketType,
} from '../../../_interfaces/service-ticket-model';
import {
  GetTickets$Params,
  getTickets,
} from '../../../api/remote-api/.portal.generated/fn/tickets/get-tickets';
import { TicketModel } from '../../../api/remote-api/.portal.generated/models';
import {
  MapApiService,
  keyBySerialAndMaterialNumber,
} from '../../shared/services/map-api.service';
export interface HttpRequestState<T> {
  loading: boolean;
  result?: T;
  error?: HttpErrorResponse | Error;
}

export type TicketModelFIXED = Omit<
  TicketModel,
  'ticketType' | 'status' | 'operationalState'
> & {
  operationalState: OperationalState;
  ticketType: TicketType;
  status: TicketStatus;
};

export type TParams = Omit<Omit<GetTickets$Params, 'start'>, 'end'> & {
  start?: Date;
  end?: Date;
};

@Injectable({
  providedIn: 'root',
})
export class ServiceTicketsService {
  getTickets = this.mapApiService.mapEndpoint(getTickets, {
    customCacheKey: (params: TParams) => {
      return (
        keyBySerialAndMaterialNumber(params) +
        JSON.stringify({ start: params.start, end: params.end })
      );
    },
    processParams: (params: TParams) => ({
      ...params,
      start: moment(params.start).subtract(365, 'days').format('YYYY-MM-DD'),
      end: moment(params.end).format('YYYY-MM-DD'),
    }),
    processResult: (tickets) => {
      return tickets as unknown as Observable<TicketModelFIXED[]>;
    },
  });

  constructor(protected mapApiService: MapApiService) {}
}
